import classNames from "classnames";
import Group from "./Group";
import styles from "./GroupSelectCell.module.css";
import { useTranslation } from "react-i18next";
import { convertGroupString } from "./groups";
import MoreButton from "../common/MoreButton";
import SpacingView from "../common/view/SpaingView";
import Collection from "../collection/model/Collection";
import ChipView, { ChipViewStyle } from "../common/ChipView";
import { toDecimalString } from "../common/strings";

interface GroupSelectCellProps {
  group: Group;
  collections: Collection[];

  handleOnClickCell: (group: Group) => void;
  handleOnClickMoreButton: (
    e: React.MouseEvent<HTMLDivElement>,
    group: Group
  ) => void;
}

export default function GroupSelectCell(props: GroupSelectCellProps) {
  const { t } = useTranslation();

  const containerClass = classNames(styles.container, {
    [styles.selectedContainer]: props.group.selected === true,
    [styles.readyContainer]: props.group.selected === false,
  });

  function handleOnClickMoreButton(e: React.MouseEvent<HTMLDivElement>) {
    e.stopPropagation();
    if (!props.group.isAllGroup && !props.group.isUnspecifiedGroup) {
      props.handleOnClickMoreButton(e, props.group);
    }
  }

  function getGroupCollection(): Collection | undefined {
    return props.collections
      .filter((collection) => !collection.isDefaultCollection)
      .find((collection) => collection.id === props.group.collectionId);
  }

  return (
    <>
      <div
        className={containerClass}
        onClick={() => props.handleOnClickCell(props.group)}
      >
        <div className={styles.contentContainer}>
          <div className={styles.leftContainer}>
            <span className={styles.collectionNameText}>
              {getGroupCollection()?.title ?? null}
            </span>

            <SpacingView height={4} />
            <span className={styles.groupnameText}>
              {convertGroupString(props.group)}
            </span>

            <SpacingView height={12} />
            <div className={styles.bottomLeftContainer}>
              <ChipView
                title={t("GroupSelectTermCount", {
                  termCount: toDecimalString(props.group.termCount),
                })}
                style={ChipViewStyle.normal}
              />
              {!props.group.isAllGroup && (
                <ChipView
                  title={t("GroupLearningPercentage", {
                    percentage: props.group.learningPercentange,
                  })}
                  style={ChipViewStyle.normal}
                />
              )}
              {props.group.language !== undefined && (
                <ChipView
                  title={props.group.language.name}
                  style={ChipViewStyle.normal}
                />
              )}
            </div>
          </div>

          <div className={styles.rightContainer}>
            {!props.group.isAllGroup && !props.group.isUnspecifiedGroup && (
              <MoreButton onClick={handleOnClickMoreButton} />
            )}
            {(props.group.isAllGroup || props.group.isUnspecifiedGroup) && (
              <SpacingView height={4} />
            )}
          </div>
        </div>
      </div>
    </>
  );
}
